import React, { useEffect, useState } from 'react'
import { withOktaAuth } from "@okta/okta-react";
import Placeholder from "./misc/placeholder";
import { getAppLogs } from "../helpers/api";
import { connect } from "react-redux";
import ProfilePicture from "./misc/profilePic";

const AccessLog = props => {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    getAppLogs().then((data) => {
      setLogs(data);
    });
  }, []); //will run on mount

  let users = logs.logs
    ? logs.logs.reduce((acum, obj) => {
        if (!acum.filter((u) => u.email === obj.user.email).length) {
          acum = acum.concat({ ...obj.user, count: 1 });
        } else {
          acum = acum.map((user) => {
            if (user.id === obj.user.id) {
              ++user.count;
            }
            return user;
          });
        }
        return acum;
      }, [])
    : [];

  users = users.sort((a, b) => {
    return a.count < b.count ? 1 : -1;
  });

  return props.is_user_editor ? (
    <div className="container">
      <div className="row">
        <div className="col">
          <h1 className="mt-4 mb-2">Contributor Profile Access Logs</h1>
          <hr />
          {users && (
            <>
              <h3 className="text-center">Last 100 visits</h3>
              {users.length ? (
                <ul className="list-inline text-center mt-4">
                  {users.map((user) => (
                    <li
                      key={user.id}
                      className="list-inline-item ml-3 mr-3 zoom-on-hover"
                    >
                      <ProfilePicture email={user.email} size={64} />
                      <p className="mt-2 text-muted text-uppercase small">
                        <i className="fa fa-eye" /> {user.count}
                      </p>
                    </li>
                  ))}
                </ul>
              ) : (
                <Placeholder />
              )}
            </>
          )}
          <div className="table-responsive">
            <table className="table table-hover table-striped">
              <thead>
                <tr className="bg-secondary text-white">
                  <th style={{ width: "32px" }}></th>
                  <th>User</th>
                  <th>Date</th>
                  <th>Location</th>
                  <th>Description</th>
                  <th className="text-right">Result</th>
                </tr>
              </thead>
              <tbody>
                {logs &&
                  typeof logs.logs === "object" &&
                  logs.logs[0] &&
                  logs.logs.map((log, idx) => (
                    <tr key={idx}>
                      <td>
                        <ProfilePicture email={log.user.email} size={32} />
                      </td>
                      <td>
                        <strong>{log.user.name}</strong>
                      </td>
                      <td>{log.date}</td>
                      <td>{log.location}</td>
                      <td>{log.description}</td>
                      <td className={`text-right`}>{log.result}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
            {!logs || typeof logs.logs !== "object" ? <Placeholder /> : null}
          </div>
        </div>
      </div>
    </div>
  ) : (
    <Placeholder />
  );
}

const mapStateToProps = ({ okta }) => {
  return {
    is_user_editor: okta.is_user_editor,
  };
};

export default withOktaAuth(connect(mapStateToProps)(AccessLog));